export default __webpack_public_path__ + "icon_reminder_normal.svg";